import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { driverListPageRouteName, addDriverPageRouteName } from "../constants/routes";
import { useDriverList } from "./hooks/useDriverList";
import ListHeader from "./components/list-header";
import ListFilters from "./components/list-filters";
import ListTable from "./components/list-table";
import ListModals from "./components/list-modals";

export const draftDriverPageRouteName = "/master-data/driver/draft";

const DraftDriverPage = () => {
  const navigate = useNavigate();
  const {
    columns,
    tableData,
    search,
    setSearch,
    currentPage,
    setCurrentPage,
    rowsPerPage,
    setRowsPerPage,
    sortState,
    setSortState,
    isDeleteOpen,
    setIsDeleteOpen,
    driverToDelete,
    setDriverToDelete,
    isLoading,
    isFetching,
    totalPages,
    isDeleting,
    handleConfirmDelete,
    t,
    selectedKeys,
    setSelectedKeys,
    isBulkOpen,
    setIsBulkOpen,
    stagedBulkAction,
    setStagedBulkAction,
    showBulkConfirmModal,
    setShowBulkConfirmModal,
    handleConfirmBulkDelete,
    statusModal,
    setStatusModal,
  } = useDriverList();

  const bulkRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isBulkOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (bulkRef.current && !bulkRef.current.contains(e.target as Node)) {
        setIsBulkOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isBulkOpen, setIsBulkOpen]);

  const getBulkActionLabel = (action: string | null) => {
    if (!action) return t("btn-bulk-actions" as any) || "Bulk Actions";
    if (action === "Delete") return t("bulk-action-delete" as any) || "Discard Selected";
    return action;
  };

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        t={t}
        onBack={() => navigate(driverListPageRouteName)}
        totalSelected={selectedKeys.length}
        isBulkOpen={isBulkOpen}
        setIsBulkOpen={setIsBulkOpen}
        isBulkDisabled={isDeleting}
        bulkRef={bulkRef}
        allowedBulkActions={["Delete"]}
        stagedBulkAction={stagedBulkAction}
        setStagedBulkAction={setStagedBulkAction}
        onBulkStatusUpdate={() => setShowBulkConfirmModal(true)}
        getBulkActionLabel={getBulkActionLabel}
      />

      <div className="flex flex-col gap-4">
        <ListFilters
          t={t}
          search={search}
          setSearch={setSearch}
          setCurrentPage={setCurrentPage}
        />
      </div>

      <ListTable
        t={t}
        paginatedRows={tableData}
        isLoading={isLoading}
        isFetching={isFetching}
        columns={columns}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setCurrentPage={setCurrentPage}
        selectedKeys={selectedKeys}
        setSelectedKeys={setSelectedKeys}
        sortState={sortState}
        setSortState={setSortState}
        totalPages={totalPages}
        onRowClick={(row) => navigate(`${addDriverPageRouteName}/${row.id}`, { state: { from: "draft" } })}
      />

      <ListModals
        t={t}
        isDeleteOpen={isDeleteOpen}
        setIsDeleteOpen={setIsDeleteOpen}
        driverToDelete={driverToDelete}
        setDriverToDelete={setDriverToDelete}
        onConfirmDelete={handleConfirmDelete}
        isDeleting={isDeleting}
        showBulkConfirmModal={showBulkConfirmModal}
        setShowBulkConfirmModal={setShowBulkConfirmModal}
        onConfirmBulkDelete={handleConfirmBulkDelete}
        selectedKeys={selectedKeys}
        statusModal={statusModal}
        setStatusModal={setStatusModal}
      />
    </div>
  );
};

export default DraftDriverPage;
